import { FormattedMessage } from 'react-intl';

import { Sport } from '@sorare/core/src/__generated__/globalTypes';
import { TextSwitch } from '@sorare/core/src/atoms/inputs/TextSwitch';
import { useSportContext } from '@sorare/core/src/contexts/sport';
import { fantasy, scoutingCenter } from '@sorare/core/src/lib/glossary';
import {
  PlayerSearchViewAttributes,
  StatsDisplay,
} from '@sorare/core/src/lib/playerSearchView';

import { useManagePlayerSearchView } from '../useManagePlayerSearchView';

const labels = {
  [Sport.FOOTBALL]: {
    on: scoutingCenter.last15Total,
    off: scoutingCenter.per90,
  },
  [Sport.BASEBALL]: {
    on: fantasy.total,
    off: scoutingCenter.perGame,
  },
  [Sport.NBA]: {
    on: fantasy.total,
    off: scoutingCenter.perGame,
  },
};

export const StatsDisplayToggle = () => {
  const { sport } = useSportContext();
  const { statsManager, updatePlayerSearchViewAttribute } =
    useManagePlayerSearchView();

  const statsDisplay = statsManager[PlayerSearchViewAttributes.STATS_DISPLAY];
  return (
    <TextSwitch
      value={statsDisplay}
      compact
      onChange={v =>
        updatePlayerSearchViewAttribute(
          PlayerSearchViewAttributes.STATS_DISPLAY,
          v
        )
      }
      options={[
        {
          label: <FormattedMessage {...labels[sport].on} />,
          value: StatsDisplay.TOTAL,
        },
        {
          label: <FormattedMessage {...labels[sport].off} />,
          value: StatsDisplay.PER_MATCH,
        },
      ]}
    />
  );
};
